import * as Sentry from '@sentry/react'

// getCurrentUser removed - now using Redux state for user info

export let feedback = Sentry.feedbackIntegration({
  colorScheme: 'light',
  autoInject: false,
  showBranding: false,
  isNameRequired: false,
  formTitle: 'Feedback',
  showEmail: false,
  showName: false,
  buttonLabel: 'Send Feedback',
  submitButtonLabel: 'Send Feedback',
  messagePlaceholder: 'What happened? What did you expect to happen?',
  useSentryUser: {
    name: 'name',
    email: 'email'
  }
})

let isInitialized = false

export function init (): void {
  if (isInitialized) {
    console.log('🔍 Sentry already initialized, skipping')
    return
  }

  Sentry.init({
    enabled: process.env.NODE_ENV === 'production',
    dsn: window.constants.SENTRY?.dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        unblock: [
          '.sentry-unblock',
          '[data-sentry-unblock]'
        ],
        unmask: [
          '.sentry-unmask',
          '[data-sentry-unmask]'
        ]
      }),
      feedback
    ],
    environment: window.constants.SENTRY?.environment,
    release: window.constants.COMMIT?.substring(0, 7),
    tracesSampleRate: window.constants.SENTRY?.tracesSampleRate ?? 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,

    beforeSend (event) {
      if (!event.exception) {
        return event
      }

      if (window.constants.SENTRY?.environment === 'prod') {
        return event
      }

      // User info would now come from Redux state instead
      let email = ''
      let name = ''

      Sentry.showReportDialog({
        eventId: event.event_id,
        user: {
          email,
          name
        }
      })

      return event
    }
  })

  isInitialized = true
  console.log('✅ Sentry initialized successfully')
}

export async function close (timeout?: number): Promise<void> {
  await Sentry.close(timeout)
}
